export default __webpack_public_path__ + "static/media/red.f1a1e1e6.ogg";